import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductGrade } from '@app/core/interfaces/product-grade';
import { ProductGradeContainer } from '@app/shared/product/product-grade/product-grade.container';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ProductGradeOptions } from './product-grade-options';
import { ProductSchemaInterface, StructuredDataService } from '@inshared/shared/util';

@Component({
    selector: 'cyno-product-grade',
    templateUrl: './product-grade.component.html',
    styleUrls: ['./product-grade.component.scss'],
})
export class ProductGradeComponent implements OnInit, OnDestroy {
    @Input() showTitle: boolean = true;
    @Input() showDescription: boolean = false;

    public productGrade: ProductGrade;

    public get options(): ProductGradeOptions {
        return this.parent.options;
    }

    private subscriptions: Subscription = new Subscription();

    constructor(public parent: ProductGradeContainer, private structuredDataService: StructuredDataService) {}

    ngOnInit(): void {
        if (!this.parent.productGrade$) {
            return;
        }

        this.subscriptions.add(
            this.parent.productGrade$
                .pipe(filter((productGrade) => !!productGrade))
                .subscribe((productGrade: ProductGrade) => {
                    this.productGrade = productGrade;
                    const product: ProductSchemaInterface = {
                        name: this.options.subtitle || this.options.productName,
                        description: this.options.description,
                        brand: {
                            name: 'Inshared',
                        },
                        images: [],
                        aggregateRating: {
                            ratingValue: `${this.productGrade?.gemiddelde_score.tiental}.${this.productGrade?.gemiddelde_score.decimaal}`,
                            reviewCount: productGrade?.totaal.toString(),
                            bestRating: '10',
                        },
                    };

                    this.structuredDataService.insertProductSchema(product);
                })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.structuredDataService.removeSchema();
    }
}
